import {Injectable} from '@angular/core';
import {ReportesRequestService} from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioMedicamentosHomologadosService {

  constructor( private requestUrl: ReportesRequestService ) { }

  public async getDataReporte( params: ObjectRequest, opcion: string ) {
    try {
      const response = await this.requestUrl.getRequest(
        'reporte-medicamentos-homologados/data',
        [
          params.codigoBaseDatos,
          {
            'ln_unco_admsn': params.uncoAdmision,
            'ln_opcn': params.uncoOpcion,
            'lc_unco_emprsa': params.uncoEmpresa,
            'opcion': opcion
          }

        ]
      );

      return response;

    } catch (e) {
      console.log(e);
    }

    return null;
  }

  public async getDataMedicamentosInsumos( codigoBaseDatos: string, uncoAdmision: number) {
    try {
      return await this.requestUrl.getRequest(
        'reporte-registro-medicamentos/data',
        [
          codigoBaseDatos,
          {
            'ln_admision': uncoAdmision
          }
        ]
      );
    } catch (e) {
      console.error(e);
    }
    return null;
  }
}

export interface ObjectRequest {
  codigoBaseDatos: string;
  uncoAdmision: string;
  uncoOpcion: string;
  uncoEmpresa: string;
}
